<div class="bp-modal mod-lg wrapper">
	<bp-modal-header
		[title]="
			modalType === addressBookWalletViewType.WITHDRAW
				? ('send_via' | translate: [selectedCryptocoin?.name, selectedNetwork?.name])
				: null
		"
		class="font-semibold">
		<button class="cancel-button" left (click)="back()" (keydown.enter)="back()" [tabIndex]="0">
			<strong>{{ "back" | translate }}</strong>
		</button>
		<button class="cancel-button" right (click)="cancel()" (keydown.enter)="cancel()" [tabIndex]="0">
			<strong>{{ "cancel" | translate }}</strong>
		</button>
	</bp-modal-header>
	<div class="bp-modal-body">
		<div class="bp-modal-description">
			<div class="header">
				<h2>{{ "address_book_wallet_type_title" | translate }}</h2>
				<span class="title-description">
					{{ "address_book_wallet_type_subtitle" | translate }}
					<a [href]="learnMoreUrl" target="_blank" class="learn-more-link">{{ "more_information" | translate }}</a>
				</span>
			</div>
		</div>

		<div class="bp-modal-body-section">
			<div class="wallet-type-options">
				<div class="wallet-type-option" (click)="selectWalletType(walletType.EXCHANGE)" [tabIndex]="0" (keydown.enter)="selectWalletType(walletType.EXCHANGE)">
					<div class="option-icon">
						<svg-inline src="assets/images/icons/bank.svg" alt="" />
					</div>
					<div class="option-content">
						<h3 class="option-title">{{ "travel_rule_wallet_type_wallet_on_exchange_title" | translate }}</h3>
						<p class="option-description">
							{{ "travel_rule_wallet_type_wallet_on_exchange_subtitle" | translate }}
						</p>
					</div>
					<div class="option-arrow">
						<span class="bpi__icon-caret-right"></span>
					</div>
				</div>

				<div class="wallet-type-option" (click)="selectWalletType(walletType.SELF_HOSTED)" [tabIndex]="0" (keydown.enter)="selectWalletType(walletType.SELF_HOSTED)">
					<div class="option-icon">
						<svg-inline src="assets/images/icons/user-key.svg" alt="" />
					</div>
					<div class="option-content">
						<h3 class="option-title">{{ "travel_rule_wallet_type_other_person_wallet_title" | translate }}</h3>
						<p class="option-description">
							{{ "travel_rule_wallet_type_private_wallet_subtitle" | translate }}
						</p>
					</div>
					<div class="option-arrow">
						<span class="bpi__icon-caret-right"></span>
					</div>
				</div>
			</div>

			@if(this.isBusinessOwnerType()) {
				<div class="warning-container mt-25 padding-15">
					<p class="warning-title">{{ "address_book_wallet_type_business_notification_title" | translate }}</p>
					<p class="warning-description mb-15">
						{{ "address_book_wallet_type_business_notification_subtitle" | translate }}
					</p>
				</div>
			}
		</div>
	</div>
</div>
